import { getAppSettings } from "../../api/setting/settingApi";
import {
  REMOVE_APP_SETTINGS,
  SET_APP_SETTINGS,
} from "../../constants/actionTypes";
import store from '../../store'
import {updateLastSettingDateTime, refreshNotifications} from "./authActions";

const setAppSetting = (settings) => {
  let settingsJson = JSON.stringify(settings);
  localStorage.setItem('app_settings', settingsJson);
  return {
    type: SET_APP_SETTINGS,
    payload: settings
  };
};

// Action process when logout
const removeAppSettings = () => {
  localStorage.removeItem("app_settings");
  return {
    type: REMOVE_APP_SETTINGS,
    payload: {},
  };
};


const fetchAppSettings = () => {
  //Get setting from server
  return async dispatch => {
    try {
      const settings = await getAppSettings().then(settings => settings);
      dispatch(setAppSetting(settings));
    } catch(e) {
      //
    }
  }
};

const reloadAppSettings = (settings) => (dispatch) => {
  const auth = store.getState().auth;
  if (settings != null) {
    if ('last_update_datetime' in settings) {
      if (auth.last_update_datetime !== settings.last_update_datetime) {
        dispatch(fetchAppSettings());
        store.dispatch(updateLastSettingDateTime(settings.last_update_datetime));
      }
    }
    if ('notifications' in settings) {
      store.dispatch(refreshNotifications(settings.notifications));
    }
  }
};

export { fetchAppSettings, removeAppSettings, reloadAppSettings, setAppSetting };
